(function () {
	var calcBtn = document.getElementById("keto-calculate-btn");
	if (!calcBtn) return;

	calcBtn.addEventListener("click", function () {
		var gender = document.querySelector(
			'input[name="keto_gender"]:checked',
		).value;
		var age = parseInt(document.getElementById("keto-age").value);
		var height = parseFloat(document.getElementById("keto-height").value);
		var weight = parseFloat(document.getElementById("keto-weight").value);
		var activity = parseFloat(document.getElementById("keto-activity").value);
		var goalAdj = parseInt(document.getElementById("keto-goal").value);
		var ketoType = document.querySelector(
			'input[name="ketoType"]:checked',
		).value;

		if (!age || !height || !weight) {
			alert("Please fill in all fields.");
			return;
		}

		// 1. BMR — Mifflin-St Jeor
		var bmr;
		if (gender === "male") {
			bmr = 10 * weight + 6.25 * height - 5 * age + 5;
		} else {
			bmr = 10 * weight + 6.25 * height - 5 * age - 161;
		}

		// 2. TDEE
		var tdee = bmr * activity;

		// 3. Goal adjustment
		var targetCals = Math.round(tdee + goalAdj);

		// Guard: extreme low-end inputs (small/elderly user + fat-loss deficit)
		// can drive targetCals near zero or negative, producing nonsensical or
		// NaN macro output. Bail with guidance instead.
		if (targetCals < 1000) {
			alert(
				"Your calculated daily calorie target is too low to produce a safe keto plan. Please review your inputs or consult a nutritionist for personalised advice.",
			);
			return;
		}

		// 4. Keto macro split
		var fatPct, proteinPct, carbPct;
		switch (ketoType) {
			case "standard":
				fatPct = 0.75;
				proteinPct = 0.2;
				carbPct = 0.05;
				break;
			case "moderate":
				fatPct = 0.65;
				proteinPct = 0.25;
				carbPct = 0.1;
				break;
			case "highProtein":
				fatPct = 0.6;
				proteinPct = 0.35;
				carbPct = 0.05;
				break;
		}

		var fatG = Math.round((targetCals * fatPct) / 9);
		var proteinG = Math.round((targetCals * proteinPct) / 4);
		var carbG = Math.round((targetCals * carbPct) / 4);

		// Cap net carbs at 50g
		if (carbG > 50) carbG = 50;

		// Derive totals from the actual macros so the displayed calories
		// and percentages stay consistent after the carb cap is applied.
		var displayCals = fatG * 9 + proteinG * 4 + carbG * 4;
		var displayFatPct = (fatG * 9) / displayCals;
		var displayProteinPct = (proteinG * 4) / displayCals;
		var displayCarbPct = (carbG * 4) / displayCals;

		document.getElementById("keto-resCalories").textContent =
			displayCals.toLocaleString();
		document.getElementById("keto-resFat").textContent = fatG + "g";
		document.getElementById("keto-resFatPct").textContent =
			Math.round(displayFatPct * 100) + "% of calories";
		document.getElementById("keto-resProtein").textContent = proteinG + "g";
		document.getElementById("keto-resProteinPct").textContent =
			Math.round(displayProteinPct * 100) + "% of calories";
		document.getElementById("keto-resCarbs").textContent = carbG + "g";
		document.getElementById("keto-resCarbsPct").textContent =
			Math.round(displayCarbPct * 100) + "% of calories";

		var results = document.getElementById("keto-results");
		results.classList.add("show");
		results.scrollIntoView({ behavior: "smooth", block: "nearest" });
	});
})();
